export default {"src":"/_next/static/media/cross.4a9a3f29.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};